export default __webpack_public_path__ + "static/media/block-farm.e4f386eb.svg";